import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import useIsMobile from "components/hooks/useIsMobile";
import { SxProps } from "@mui/system";

interface DigitalSubscriptionUpgradeBannerProps {
  daysLeft: number;
  sx?: SxProps;
}

export default ({ daysLeft, sx }: DigitalSubscriptionUpgradeBannerProps) => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  return (
    <Box
      sx={{
        position: "relative",
        backgroundColor: "#198282",
        padding: isMobile ? "16px" : "16px 24px",
        display: "flex",
        alignItems: isMobile ? "start" : "center",
        justifyContent: "space-between",
        gap: isMobile ? "12px" : "16px",
        zIndex: 1201,
        borderTopLeftRadius: !isMobile ? "16px" : undefined,
        marginBottom: !isMobile ? "-12px" : undefined,
        ...sx,
      }}
    >
      <Box sx={{ display: "flex", gap: "4px" }}>
        {isMobile && (
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography variant="bodyHeavy" sx={{ color: "white" }}>
              Free trial
            </Typography>
            <Typography variant="bodyHeavy" sx={{ color: "white" }}>
              ({daysLeft} day{daysLeft !== 1 ? "s" : ""} left)
            </Typography>
          </Box>
        )}
        {!isMobile && (
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography variant="h5" sx={{ color: "white" }}>
              Free trial ({daysLeft} day{daysLeft !== 1 ? "s" : ""} left)
            </Typography>
            <Typography variant="body" sx={{ color: "white" }}>
              Choose a plan to keep access to your Family Hub after your trial
              ends.
            </Typography>
          </Box>
        )}
      </Box>

      <Button
        variant={isMobile ? "text" : "outlined"}
        size={isMobile ? "small" : "medium"}
        onClick={() => navigate("/digital-upgrade")}
        endIcon={<ArrowRight size={20} />}
        fullWidth={isMobile}
        sx={{
          color: "white",
          borderColor: "white",
          whiteSpace: "nowrap",
          width: "auto",
        }}
      >
        Upgrade plan
      </Button>
    </Box>
  );
};
